import { request } from "app/utils/request";
import { Dispatch } from "react";
import { action, ActionType } from "typesafe-actions";
import config from "config/environment";
import { PostingModel, PostModel } from "app/models/PostModel";
import { store } from "app/Store";

const pending = () => action("@postingForm.fetch.pending");
const error = (err: string) => action("@postingForm.fetch.error", err);
export const displayError = (err: string) =>
  action("@postingForm.fetch.displayError", err);
const success = (post: any) => action("@postingForm.fetch.success", post);

export const postLocation = (location: string[]) =>
  action("@postingForm.fetch.postLocation", location);

export const clearPost = () => action("@postingForm.clear");

const thisActions = {
  pending,
  error,
  displayError,
  success,
  postLocation,
  clearPost,
};

export type PostingFormAction = ActionType<typeof thisActions>;

export function fetchPost(post_id: string) {
  return (dispatch: Dispatch<PostingFormAction>) => {
    dispatch(pending());

    const url = config.API_SERVER + `/api/v2.1/posts/${post_id}`;
    const promise = request(url, "GET", {}, { version: 1 });
    promise.then((views) => dispatch(success(views)));
    promise.catch((err) => dispatch(error(err)));

    return promise;
  };
}

export function createPost(post: PostModel | PostingModel) {
  return (dispatch: Dispatch<PostingFormAction>) => {
    dispatch(pending());

    const self = store.getState().user.self;
    const url = config.API_SERVER + `/api/v2.1/posts`;
    const promise = request(
      url,
      "POST",
      {
        post: {
          ...post,
          assignTagsToResources: self?.assignTagsToResources ?? false,
        },
      },
      { version: 1 },
    );
    promise.then((views) => dispatch(success(views)));
    promise.catch((err) => dispatch(error(err)));

    return promise;
  };
}

export function editPost(
  post: (Omit<PostModel, "tags"> & { tags?: string[] }) | PostModel,
) {
  return (dispatch: Dispatch<PostingFormAction>) => {
    dispatch(pending());

    const url = config.API_SERVER + `/api/v2.1/posts/${post.id}`;
    const promise = request(url, "PUT", { post }, { version: 1 });
    promise.then((views) => dispatch(success(views)));
    promise.catch((err) => dispatch(error(err)));

    return promise;
  };
}

export function deletePost(postId: string) {
  return (dispatch: Dispatch<PostingFormAction>) => {
    dispatch(pending());

    const url = config.API_SERVER + `/api/v2.1/posts/${postId}`;
    const promise = request(url, "DELETE", {}, { version: 1 });
    promise.then((views) => dispatch(success(views)));
    promise.catch((err) => dispatch(error(err)));

    return promise;
  };
}
